import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {getCurrentUser, request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu} from 'antd';
import Icon from "antd/es/icon";
import RegionForm from "./RegionForm";
import RegionDeleteModal from "./RegionDeleteModal";
import {showAxiosError} from "../../util/Helpers";
import RegionPharmacyModal from "./RegionPharmacyModal";

class Region extends Component {

    constructor(props) {
        super(props);

        this.state = {
            regions: [],
            error: null,
            loading: false,
            editingRegion: null,
            isModalVisible: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,
            selectedRegion: null,

            note: true,
            add: false,
            currentUser:[],
            userId: null,
            selectedItem: null,
            branches: null,
            roles: null,
            totalIdList: [],
            debtList: [],
            cities: null,
            citySubdivisions: null,
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            manual: false,
            isEditModalOpen: false,
            regionPharmacyModal: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
            action: '',
            isLoading: false,
        };
        this.cancelProcess = this.cancelProcess.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.fetchRegion = this.fetchRegion.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handlePharmacyButtonClick = this.handlePharmacyButtonClick.bind(this);
    }


    fetchRegion(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
       let searchQuery = self.state.searchQuery ?  '&' + self.state.searchQuery : "";
        let url;

        url = API_BASE_URL + "/regions?page=" + page + "&size=" + size + sortStr + searchQuery ;

        let params = {
            url: url,
            method: "get",
        };
        self.setState({loading: true,
            searching: true});
        request(params)
            .then(function (response) {
                let totalChanged = false;
                if (response.data.totalElements !== self.state.total) {
                    totalChanged = true;
                }
                self.setState({
                    page:page,
                    size: size,
                    total: response.data.totalElements,
                    regions: response.data.content,
                    totalIdList: response.data && response.data.content.map(region => region.id),
                    debtList: response.data.content.map(region => region.debt),

                    loading: false,

                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false, error: "Bölgeler yüklenirken bir sorun oluştu."});
            showAxiosError(error);
        });
    }
    handleLogout() {
        this.props.handleLogout();
    }
    cancelProcess() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add:false,
            regionPharmacyModal:false,
        })
        this.fetchRegion()
    }

    handleEdit(item) {
        this.setState({
            selectedRegion: item,
            isEditModalOpen: true,
        })
    }

    handleDelete(item) {
        this.setState({
            selectedRegion: item,
            addDeleteModal: true
        })
    }
    addNew(item) {
        this.setState({
            selectedRegion: null,
            isEditModalOpen: true,
            add:true
        })
    }
    handlePharmacy(item) {
        this.setState({
            selectedRegion: item,
            regionPharmacyModal: true,
        })
    }
    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchRegion(
            this.state.accessor,
            this.state.direction,
            page,
            this.state.size
        ))
    }

    handleMenuClick(e) {
        let self = this;
        if (e.key === '1') {
            this.handlePharmacy(self.state.selectedItem);
        }else if (e.key === '2') {
            this.handleEdit(self.state.selectedItem);
        } else if (e.key === '3') {
            this.handleDelete(self.state.selectedItem);
        }
    }
    handlePharmacyButtonClick = () => {
        this.props.history.push("/pharmacyList");
    };
    render() {
        let self = this;
        console.log("regions", this.state.regions)
        console.log("selectedRegionPharmacies", this.state.selectedRegionPharmacies)

        const menu = (
            <Menu onClick={self.handleMenuClick}>
                {
                    self.state.selectedItem &&
                    <Menu.Item key="1">
                        Eczane Görüntüle
                    </Menu.Item>
                }
                {
                    self.state.selectedItem &&
                    <Menu.Item key="2">
                        Bölge Düzenle
                    </Menu.Item>
                }
                {
                    self.state.selectedItem &&
                    <Menu.Item key="3">
                        Bölge Sil
                    </Menu.Item>
                }
            </Menu>
        );
        const columns = [
            {
                Header: "Bölge Adı",
                accessor: "regionName",
            },
            // {
            //     Header: "Telefon",
            //     accessor: "phone",
            // },
            // {
            //     Header: "Adres",
            //     accessor: "location",
            //     // Cell: (item) => {
            //     //     return <label>
            //     //         {item.evrakNo}
            //     //     </label>
            //     // }
            // },
            // {
            //     Header: "İlçe",
            //     accessor: "district",
            //     // Cell: item => (
            //     //     <label>Şanlıurfa</label>
            //     // )
            // },

            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu} trigger='click' onClick={() => self.setState({selectedItem: item})}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }

        ];

        const fields = [
            // {
            //     label: "Eczane Adı",
            //     accessor: "name",
            //     type: "text",
            //     operator: "=",
            // },

            {
                label: "Bölge",
                accessor: "regionName",
                type: "text",
                operator: "=",
            },
            // {
            //     label: "İlçe",
            //     accessor: "district",
            //     type: "text",
            //     operator: "=",
            //     // selectData: branchSelectdata,
            // },

        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Bölge Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.regions}
                            total={this.state.total}
                            page={this.state.page}
                            // manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.fetchRegion}
                            style={{width:"100%"}}
                        />
                    </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Yeni Bölge Ekle" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '160px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                    marginBottom:"5px",
                                }}
                                className="TekBtn add-new-member "
                                rel="tooltip"
                                onClick={() => this.addNew(this.state.selectedItem)}>
                            YENİ BÖLGE EKLE
                        </button>
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Eczane İşlemleri" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient((rgba(159, 208, 55, 0.6), rgb(159, 208, 55)))',
                                    height: '40px',
                                    width: '160px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                rel="tooltip" className="TekBtn regions "

                                onClick={this.handlePharmacyButtonClick}>
                            Eczane İşlemleri
                        </button>
                    </div>
                </div>
                <Modal isOpen={this.state.regionPharmacyModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDocumentCreation}>
                        Eczaneler
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <RegionPharmacyModal
                            cancelProcess={this.cancelProcess}
                            selectedRegion={this.state.selectedRegion}
                            mode={this.state.mode}
                            module={this.props.name} cities={this.state.cities}
                            handleSearch={this.handleSearch}
                            searchQuery={this.state.searchQuery}
                            branches={this.state.branches}
                            handleLogout={this.handleLogout}
                            regions={this.state.regions}
                            selectedRegionPharmacies={this.state.selectedRegionPharmacies}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isEditModalOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelProcess}>
                        {this.state.add
                            ?
                            'Yeni Bölge Ekleme'
                            :
                            'Bölge Düzenleme'
                        }
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <RegionForm
                            cancelProcess={this.cancelProcess}
                            selectedRegion={this.state.selectedRegion}
                            currentUser={this.props.currentUser}
                            mode={this.state.mode}
                            module={this.props.name}
                            handleSearch={this.handleSearch}
                            searchQuery={this.state.searchQuery}
                            regions={this.state.regions}
                            handleLogout={this.handleLogout}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelProcess}>
                        Eczane Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <RegionDeleteModal
                            cancelProcess={this.cancelProcess}
                            selectedRegion={this.state.selectedRegion}
                            handleLogout={this.handleLogout}
                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default Region;



// WEBPACK FOOTER //
// ./src/page/regions/Region.js